import React from 'react';
import { Box } from '@chakra-ui/react';
import { Group, Panel, Separator, useDefaultLayout } from 'react-resizable-panels';

const GROUP_ID = 'vorakit-browse-category-list';
const PANEL_CATEGORIES = 'browse-categories';
const PANEL_LIST = 'browse-list';

type Props = {
  categoryColumn: React.ReactNode;
  listColumn: React.ReactNode;
};

/** Horizontal split: categories | channels/items — sizes persist in localStorage. */
export function ResizableBrowseSplit({ categoryColumn, listColumn }: Props) {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: GROUP_ID,
    panelIds: [PANEL_CATEGORIES, PANEL_LIST],
    storage: localStorage,
  });

  return (
    <Group
      id={GROUP_ID}
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
      style={{ flex: 1, minHeight: 0, minWidth: 0, overflow: 'hidden' }}
    >
      <Panel id={PANEL_CATEGORIES} defaultSize="20%" minSize="14%" maxSize="48%">
        <Box h="100%" minH={0} overflow="hidden" display="flex" flexDirection="column">
          {categoryColumn}
        </Box>
      </Panel>
      <Separator
        style={{
          width: 8,
          minWidth: 8,
          background: 'rgba(255, 255, 255, 0.06)',
        }}
      />
      <Panel id={PANEL_LIST} defaultSize="80%" minSize="40%">
        <Box h="100%" minH={0} minW={0} overflow="hidden" display="flex" flexDirection="column" pl={3}>
          {listColumn}
        </Box>
      </Panel>
    </Group>
  );
}
